/** Recipients above this count require explicit confirmed=true to send. */
export const MARKETING_SEND_CONFIRM_THRESHOLD = 25;

/** Worker chunk size for newsletter fan-out jobs. */
export const MARKETING_NEWSLETTER_SEND_CHUNK_SIZE = 100;

export const MARKETING_NEWSLETTER_SEND_QUEUE = 'marketing-newsletter-send';

export type MarketingNewsletterSendJob = {
  sendId: string;
  recipientIds: string[];
};
